'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fButton$002ejs from "@ui5/webcomponents/dist/Button.js";
import * as $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent from "./be.doeraene.webcomponents.-Web-Component.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024 from "./com.raquo.laminar.tags.-Custom-Html-Tag$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_Button$() {
  this.CP = null;
  $n_Lbe_doeraene_webcomponents_ui5_Button$ = this;
  $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent.$f_Lbe_doeraene_webcomponents_WebComponent__$init$__V(this);
  $i_$0040ui5$002fwebcomponents$002fdist$002fButton$002ejs.default;
  this.CP = new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_tags_CustomHtmlTag("ui5-button", $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$().eO(), ($j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$(), (void 0)));
}
export { $c_Lbe_doeraene_webcomponents_ui5_Button$ as $c_Lbe_doeraene_webcomponents_ui5_Button$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_Button$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_Button$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_Button$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_Button$ as $h_Lbe_doeraene_webcomponents_ui5_Button$ };
$h_Lbe_doeraene_webcomponents_ui5_Button$.prototype = $p;
$p.fP = (function(x$0) {
});
$p.ec = (function() {
  return this.CP;
});
var $d_Lbe_doeraene_webcomponents_ui5_Button$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_Button$, "be.doeraene.webcomponents.ui5.Button$", ({
  gd: 1,
  ar: 1,
  bk: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_Button$ as $d_Lbe_doeraene_webcomponents_ui5_Button$ };
var $n_Lbe_doeraene_webcomponents_ui5_Button$;
function $m_Lbe_doeraene_webcomponents_ui5_Button$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_Button$)) {
    $n_Lbe_doeraene_webcomponents_ui5_Button$ = new $c_Lbe_doeraene_webcomponents_ui5_Button$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_Button$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_Button$ as $m_Lbe_doeraene_webcomponents_ui5_Button$ };
